import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import appUrl from "../../../../constants/appUrl";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Products = () => {

    const [productList, setProductList] = useState([]);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    const GetComponent = async () => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/DashboardComponent/GetAllComponents`)
            const data = await response.json();
            setProductList(data)

        } catch (error) {
            console.error('Error fetching components:', error);
        }
    }

    useEffect(() => {
        GetComponent();
    }, []);


    return (
        <>
            <div className="card">
                <Slider {...settings}>
                    <div>
                        <img src={'assets/layout/images/banner-primeblocks-dark.png'} style={{ width: '100%', height: '40vh' }} alt="logo" />
                    </div>
                    <div>
                        <img src={'assets/layout/images/banner-primeblocks-dark.png'} style={{ width: '100%', height: '40vh' }} alt="logo" />
                    </div>
                    <div>
                        <img src={'assets/layout/images/banner-primeblocks-dark.png'} style={{ width: '100%', height: '40vh' }} alt="logo" />
                    </div>
                </Slider>
            </div>
            <div className='grid'>
                <div className='md:col-8'>
                    <div className='card'>
                        <div className='grid'>
                            {/* Mapping through the array of components and rendering component elements */}
                            {productList && productList.map(component => (
                                <div key={component.componentID} className='md:col-3'>
                                    <div className='card bg_custom'>
                                        <Link className="clr_custom" to={`/AgainstProductProcess`}>
                                            <h4>{component.componentName}</h4>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='md:col-4'>
                    <div className='card'>
                        <h4>Tip of the day</h4>
                        <p>xyz</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Products;
